import React from 'react';
import dash1 from '../../images/dash1.png';
import dash2 from '../../images/dash2.png';
import dash3 from '../../images/dash3.png';
import dash4 from '../../images/dash4.png';

const TestimonialsSection = () => {
  
    const testimonials = [
    {
      name: "Sarah Smith",
      rating: 5,
      text: "Since I joined this insurance company, I feel I have extraordinary experience. Their customer service was very responsive and helpful.",
      bgColor: "bg-[#fff3f7]",
      iconColor: dash1
    },
    {
      name: "Sarah Smith",
      rating: 5,
      text: "Since I joined this insurance company, I feel I have extraordinary experience. Their customer service was very responsive and helpful.",
      bgColor: "bg-[#f5ffed]",
      iconColor: dash2
    },
    {
      name: "Sarah Smith",
      rating: 5,
      text: "Since I joined this insurance company, I feel I have extraordinary experience. Their customer service was very responsive and helpful.",
      bgColor: "bg-[#ebf8ff]",
      iconColor: dash3
    }
  ];

  const testimonialColumns = [
    [
      { ...testimonials?.[0], bgColor: "#fff3f7", iconColor: dash1 },
      { ...testimonials?.[1], bgColor: "#f5ffed", iconColor: dash2 },
      { ...testimonials?.[2], bgColor: "#ebf8ff", iconColor: dash3 }
    ],
    [
      { ...testimonials?.[0], bgColor: "#fffce7", iconColor: dash4 },
      { ...testimonials?.[1], bgColor: "#ebf8ff", iconColor: dash3},
      { ...testimonials?.[2], bgColor: "#fff3f7", iconColor: dash1 }
    ],
    [
      { ...testimonials?.[0], bgColor: "#ebf8ff", iconColor: dash3 },
      { ...testimonials?.[1], bgColor: "#fff3f7", iconColor: dash1 },
      { ...testimonials?.[2], bgColor: "#f5ffed", iconColor: dash2}
    ]
  ];

  return (
    <section className="testimonials_section section_space">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <span className="sub_heading">TESTIMONIALS</span>
            <br/>
            <br/>
            <div className="heading_block">
              <h2 className="heading_text heading_top">What our users say</h2>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          {testimonialColumns.map((column, columnIndex) => (
            <div
                className={`col-lg-4 col-md-6 mb-4 ${
                    columnIndex === 0
                    ? 'moveUpOnly'
                    : columnIndex === 1
                    ? 'moveDownOnly'
                    : 'moveUpOnly'
                }`}
                key={columnIndex}
                >
            {column?.map((t, idx) => (
              <div className="card" style={{ backgroundColor: t.bgColor, border: '1px solid #000', borderRadius: '12px', marginBottom: '20px' }} key={idx}>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <img src={t.iconColor} alt={t.name} style={{ width: 30, height: 23, marginRight: 12 }} />
                    <h5 className="mb-0">{t.name}</h5>
                  </div>
                  <p className="card-text">{t.text}</p>
                  <div className="d-flex align-items-center mt-3">
                    <div style={{ width: 48, height: 48, background: 'linear-gradient(135deg,#e0e0e0,#d0d0d0)', borderRadius: 6, marginRight: 12 }}></div>
                    <div>
                      <strong>{t.name}</strong>
                      <div className="text-muted star-rating">{'★'.repeat(t.rating)}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes moveUpOnly {
          0% { transform: translateY(60px); }
          50% { transform: translateY(-60px); }
          100% { transform: translateY(60px); }
        }
        
        @keyframes moveDownOnly {
          0% { transform: translateY(-60px); }
          50% { transform: translateY(60px); }
          100% { transform: translateY(-60px); }
        }

        /* apply animation to the classes used in JSX (moveUpOnly / moveDownOnly) */
        .moveUpOnly {
          animation: moveUpOnly 8s ease-in-out infinite;
          will-change: transform;
        }
        .moveDownOnly {
          animation: moveDownOnly 8s ease-in-out infinite;
          will-change: transform;
        }
      `}</style>

    </section>
  );
};

export default TestimonialsSection;